// extracted by mini-css-extract-plugin
export default {"wrapper":"ModalAddFriend_wrapper__5XxJz"};